import { mobileMappingStatus } from 'api/constants';
import { get } from "../../../../logics/src/utils/helpers";


interface VerifyMobileResponseParams {
  response: {
    editingAllowed: boolean,
    status: string,
  },
  message: string;
  status: string,
}

export const verifyMobileEligibilityTransformer = (originalResponse: VerifyMobileResponseParams) => {
  if (get(originalResponse, 'status') == 'success' && get(originalResponse, 'response')) {
    const {
      status,
      editingAllowed,
    } = originalResponse.response || {};


    let isEligibleForVerify = false;
    switch (status) {
      case mobileMappingStatus.GUEST_OR_INVALID: // 0
      case mobileMappingStatus.VERIFIED: // 1
        break;
      case mobileMappingStatus.MULTIPLE_OR_NO_MOBILE_FOUND: // 2
      case mobileMappingStatus.MOBILE_FOUND_BUT_LINKED: // 4
        if (editingAllowed) {
          isEligibleForVerify = true;
        }

        break;
      case mobileMappingStatus.MOBILE_FOUND: // 3
      case mobileMappingStatus.UNVERIFIED: // 5
        isEligibleForVerify = true;
        break;
      default:
        break;
    }

    return {
      success: true,
      isEligibleForVerify,
      editingAllowed: originalResponse.response.editingAllowed || false,
    };
  }

  if (get(originalResponse, 'status') == 'fail') {
    return {
      success: false,
      isEligibleForVerify: false,
      editingAllowed: false,
      message: originalResponse.message,
    };
  }

  return {
    success: false,
    editingAllowed: false,
    isEligibleForVerify: false,
    message: originalResponse.message || '',
  };
};
